import { render } from "./NameHeading.vue?vue&type=template&id=2c8d82b7&ts=true"
import script from "./NameHeading.vue?vue&type=script&lang=ts"
export * from "./NameHeading.vue?vue&type=script&lang=ts"

import "./NameHeading.vue?vue&type=style&index=0&id=2c8d82b7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__